import React from "react";
import { Container, Typography, Card, CardContent, Grid, Box } from "@mui/material";
import { LocationOn, Email, Phone } from "@mui/icons-material";
import { motion } from "framer-motion";

function ContactContent() {
  return (
    <Container maxWidth="lg">
      {/* Header */}
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}>
        <Typography variant="h4" align="center" gutterBottom>
          📞 Contact Us
        </Typography>
      </motion.div>

      {/* Contact Details */}
      <Grid container spacing={4}>
        {/* Address */}
        <Grid item xs={12} md={4}>
          <motion.div initial={{ x: -50, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 0.5 }}>
            <Card elevation={3}>
              <CardContent>
                <LocationOn color="primary" fontSize="large" />
                <Typography variant="h6">Our Address</Typography>
                <Typography variant="body2">
                  MBPE Office, Industrial Area, Ambala, India
                </Typography>
              </CardContent>
            </Card>
          </motion.div>
        </Grid>

        {/* Email */}
        <Grid item xs={12} md={4}>
          <motion.div initial={{ y: -50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.5 }}>
            <Card elevation={3}>
              <CardContent>
                <Email color="primary" fontSize="large" />
                <Typography variant="h6">Email Us</Typography>
                <Typography variant="body2">support@mbpe.com</Typography>
              </CardContent>
            </Card>
          </motion.div>
        </Grid>

        {/* Phone */}
        <Grid item xs={12} md={4}>
          <motion.div initial={{ x: 50, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 0.5 }}>
            <Card elevation={3}>
              <CardContent>
                <Phone color="primary" fontSize="large" />
                <Typography variant="h6">Call Us</Typography>
                <Typography variant="body2">+91 98765 43210</Typography>
              </CardContent>
            </Card>
          </motion.div>
        </Grid>
      </Grid>

      {/* Safety Section */}
      <Box mt={5}>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
          <Typography variant="h5" align="center" gutterBottom>
            🛡️ Safety First
          </Typography>
        </motion.div>
        <Grid container spacing={4}>
          {/* Safety Statement */}
          <Grid item xs={12} md={6}>
            <motion.div initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.6 }}>
              <Card elevation={3}>
                <CardContent>
                  <Typography variant="h6">Our Commitment</Typography>
                  <Typography variant="body2">
                    MBPE is dedicated to providing a safe and healthy working environment.
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>

          {/* Safety Policy */}
          <Grid item xs={12} md={6}>
            <motion.div initial={{ y: 50, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.6 }}>
              <Card elevation={3}>
                <CardContent>
                  <Typography variant="h6">Safety Policy</Typography>
                  <Typography variant="body2">
                    We enforce strict safety training and equipment maintenance to minimize hazards.
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        </Grid>
      </Box>

      {/* Google Map */}
      <Box mt={5} style={{ textAlign: "center" }}>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }}>
          <Typography variant="h5" gutterBottom>
            📍 Find Us on Map
          </Typography>
          <iframe
            title="MBPE Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224345.83937332547!2d76.849662!3d28.669156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d0348c85b18d3%3A0x191e6b6474a1e65d!2sIndustrial%20Area%2C%20Ambala!5e0!3m2!1sen!2sin!4v1646595831542!5m2!1sen!2sin"
            width="100%"
            height="300"
            style={{ border: "0", borderRadius: "10px" }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </motion.div>
      </Box>
    </Container>
  );
}

export default ContactContent;
